<!-- src\components\View632.vue -->
<template>
	<div :class="[`view-129`, className || ``]">
		<h1 class="text-192">{{ title || '' }}</h1>
		<span v-if="subtitle" class="text-191">{{ subtitle }}</span>
	</div>
</template>

<script>
export default {
	name: 'View632',
	props: ['className', 'title', 'subtitle'],
}
</script>

<style>
.view-129 {
	position: absolute;
	top: 9px;
	left: 50%;
	transform: translateX(-50%);

	width: min(798px, calc(100% - 40px));
	height: 83px;

	display: flex;
	flex-direction: column;
	align-items: center;        /* центр по горизонтали */
	justify-content: center;    /* центр по вертикали */
	gap: 6px;

	text-align: center;
}

/* Заголовок */
.text-192 {
	font-family: 'FontAwesome5Free-Solid', Arial, sans-serif;
	font-size: 30px;
	font-weight: 700;
	color: white;
	letter-spacing: 0;
	line-height: 1.2;

	width: 100%;
	margin: 0;

	/* чтобы текст не ломал верстку */
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* Подзаголовок */
.text-191 {
	font-family: 'FontAwesome5Free-Solid', Arial, sans-serif;
	font-size: 22px;
	font-weight: 500;
	color: white;
	letter-spacing: 0;
	line-height: 1.2;

	width: 100%;
	margin: 0;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* режим view-133 */
.view-129.view-133 {
	position: unset;
	top: unset;
	left: unset;
	transform: unset;

	margin-left: 53px;
	margin-top: 9px;

	align-items: flex-start;
	text-align: left;
}

/* collapsed оставляем (можно уже почти не нужен) */
.view-129.view-129-collapsed {
	left: 50%;
	transform: translateX(-50%);
	align-items: center;
	justify-content: center;
	text-align: center;
}

</style>

